import { homeCopy } from "./content/home-copy";

/** Aplica textos de `home-copy.ts` cuando `body[data-page="home"]`. */
export function applyHomeCopy(): void {
  if (document.body.dataset.page !== "home") return;

  const badge = document.querySelector("[data-home-badge]");
  if (badge) badge.textContent = homeCopy.heroBadge;

  const title = document.querySelector("[data-home-hero-title]");
  if (title) title.innerHTML = homeCopy.heroTitleHtml;

  const lead = document.querySelector("[data-home-hero-lead]");
  if (lead) lead.textContent = homeCopy.heroLead;

  const ctaPrimary = document.querySelector<HTMLAnchorElement>("[data-home-cta-primary]");
  if (ctaPrimary) {
    ctaPrimary.textContent = homeCopy.heroPrimaryCta.label;
    ctaPrimary.href = homeCopy.heroPrimaryCta.href;
  }

  const ctaSecondary = document.querySelector<HTMLAnchorElement>("[data-home-cta-secondary]");
  if (ctaSecondary) {
    ctaSecondary.textContent = homeCopy.heroSecondaryCta.label;
    ctaSecondary.href = homeCopy.heroSecondaryCta.href;
  }

  const vpTitle = document.querySelector("[data-home-value-title]");
  if (vpTitle) vpTitle.textContent = homeCopy.valuePropTitle;

  const vpLead = document.querySelector("[data-home-value-lead]");
  if (vpLead) vpLead.textContent = homeCopy.valuePropLead;

  const fmtTitle = document.querySelector("[data-home-formats-title]");
  if (fmtTitle) fmtTitle.textContent = homeCopy.formatsTitle;

  const fmtSub = document.querySelector("[data-home-formats-sub]");
  if (fmtSub) fmtSub.textContent = homeCopy.formatsSub;
}